/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useState, useEffect } from 'react';
import defer from 'hs-promise-utils/defer';
export const useOwners = fetchOwners => {
  const [owners, setOwners] = useState([]);
  useEffect(() => {
    const deferredRequest = defer();
    fetchOwners().then(deferredRequest.resolve);
    deferredRequest.promise.then(setOwners).catch(console.warn);
    return () => {
      deferredRequest.reject('[rich-text-lib][personalization][fetchOwners] component unmounting abort state update');
    };
  }, [fetchOwners]);
  return owners;
};